/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createFileResponseFromDiscriminatorValue, createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, serializeFileCopyRequest, serializeFileResponse, type FileCopyRequest, type FileResponse, type HttpValidationProblemDetails, type IError } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /files/{file-id}/copy
 */
export interface CopyRequestBuilder extends BaseRequestBuilder<CopyRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<FileResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     post(body: FileCopyRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<FileResponse | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: FileCopyRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const CopyRequestBuilderUriTemplate = "{+baseurl}/files/{file%2Did}/copy";
/**
 * Metadata for all the requests in the request builder.
 */
export const CopyRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: CopyRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createFileResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeFileCopyRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
